import axiosInstance from "../utils/api";
import noEncryptInstance from "../utils/noEncryptApi";

const raiseClaimService = {
    fetchAll: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-all-CliamRaise', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    fetchById: async (policyTypeId) => {
        try {
            const result = await axiosInstance.post('/RaiseClaim/get-CliamTeplate/PolicyTypeId', { policyTypeId: policyTypeId });
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    getPolicyNumber: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-PolicyNumber/PolicyNameId', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    addUpdate: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/add-update-raise-claim', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    updateClaimStatusByAdmin: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/update-claim-status-by-admin', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    raiseClaimDetails: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-CliamRaiseDetails/ClaimRaiseId', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    downloadClaimFile: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/download-raiseclaimfile', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    getLorDetails: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/lor-get', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    downloadLor: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/lor-download', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    uploadLor: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/lor-upload', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    fetchRemarksHistory: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-all-remarks', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    addRemarks: async (payload) => {
        try {
            const result = await axiosInstance.post('/RaiseClaim/add-remarks', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    getLorList: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-lor-document-list', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    addLorList: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/add-lor-document-list', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    getClaimSettlement: async (payload) => {
        try {
            const result = await axiosInstance.post('External/Claims/get-claim-settlement', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    getClaimSettlementTat: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-claim-settlement-tat', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    addClaimSettlement: async (payload) => {
        try {
            const result = await axiosInstance.post('/External/Claims/add-update-claim-settlement', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    addSalvageAmount: async (payload) => {
        try {
            const result = await axiosInstance.post('/External/Claims/add-claim-savage-data', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    fetchAllChats: async (payload) => {
        try {
            const result = await axiosInstance.post('/ClaimChatHistories/get-all-chats', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },

    sendChat: async (payload) => {
        try {
            const result = await axiosInstance.post('/ClaimChatHistories/add-chat', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    updateByInsurer: async (payload) => {
        try {
            const result = await axiosInstance.post('External/Claims/update-claim-status-by-insurer', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    updateBySurveyor: async (payload) => {
        try {
            const result = await noEncryptInstance.post('External/Claims/update-claim-status-by-surveyor', payload);
            return result;
        }
        catch (error) {
            return error.response;
        }
    },
    getClaimDocumentDetails: async (payload) => {
        try {
            const result = await axiosInstance.post('RaiseClaim/get-files', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    addJirAndLor: async (payload) => {
        try {
            const result = await noEncryptInstance.post('/External/Claims/upload-jir-and-lor-by-surveyor', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    addFiles: async (payload) => {
        try {
            const result = await noEncryptInstance.post('/RaiseClaim/upload-files', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    deleteDoc: async (payload) => {
        try {
            const result = await axiosInstance.post('/RaiseClaim/delete-files', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    addComment: async (payload) => {
        try {
            const result = await axiosInstance.post('/RaiseClaim/add-comments', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    },

    deleteRequiredName: async (payload) => {
        try {
            const result = await axiosInstance.post('/RaiseClaim/delete-lor-required-or-other-required', payload);
            return result.data;
        }
        catch (error) {
            return error.response;
        }
    }

};

export default raiseClaimService;
